import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom'; 
import '../App.css';

function ChooseScenario({ name }) {
    const [scenarios, setScenarios] = useState([]);
    const token = localStorage.getItem('token');
    const navigate = useNavigate(); 
    const { workspaceName } = useParams();
    const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';
    useEffect(() => {
        loadScenarios();
    }, []);

    const loadScenarios = async () => {// Shows all scenarios
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            const res = await axios.get(`${API_URL}/api/scenarios/${workspaceName}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            setScenarios(res.data); 
        } catch (err) {
            console.error('Error loading scenarios:', err);
        }
    };

    const toggleScenario = async (scenario) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            const updated = { ...scenario, isActive: !scenario.isActive };
            await axios.put(`${API_URL}/api/scenarios/${workspaceName}/${scenario._id}`, updated, {
                headers: { Authorization: `Bearer ${token}` },
            });
            loadScenarios();
        } catch (err) {
            console.error('Error toggling scenario:', err);
        }
    };

    const runScenario = async (scenarioId) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            await axios.post(`${API_URL}/api/scenarios/${workspaceName}/${scenarioId}/run`, null, {
                headers: { Authorization: `Bearer ${token}` },
            });
            alert('Сценарий успешно запущен');
        } catch (err) {
            console.error('Error running scenario:', err);
        } 
    };

    const deleteScenario = async (scenarioId) => {
        try {
            const token = localStorage.getItem('token');
            if (!token) throw new Error('No token found, user is not authenticated');

            await axios.delete(`${API_URL}/api/scenarios/${workspaceName}/${scenarioId}`, {
                headers: { Authorization: `Bearer ${token}` },
            });
            loadScenarios();
        } catch (err) {
            console.error('Error deleting scenario:', err);
            alert('Ошибка при удалении сценария');
        }
    };

    const handleEditScenario = (scenarioId, scenarioName) => {
        navigate(`/add-scenario/${workspaceName}?scenarioId=${scenarioId}&scenarioName=${scenarioName}`);
                         //navigate(`/add-scenario?scenarioId=${scenarioId}&scenarioName=${scenarioName}`);
    };

    return (
        <div>
            <h2>Список сценариев для "{workspaceName}"</h2>
            {scenarios.length === 0 ? (
                <div style={{ textAlign: 'center', marginTop: '20px' }}>
                    <p>Список сценариев пуст.</p>
                </div>
            ) : (
            scenarios.map((scn) => (
                <div
                    key={scn._id}
                    style={{
                        border: '1px solid #ccc',
                        margin: '10px',
                        padding: '10px'
                    }}
                >
                    <div><strong>Название:</strong> {scn.scenarioName}</div>
                    <div><strong>Статус:</strong> {scn.isActive ? 'Включен' : 'Выключен'}</div>

                    {/* Optional: Show a brief summary of triggers */}
                    {scn.triggers && scn.triggers.length > 0 && (
                        <div style={{ marginTop: '8px' }}>
                            <strong>Триггеры:</strong>
                            {scn.triggers.map((t, idx) => (
                                <div key={idx} style={{ marginLeft: '15px' }}>
                                    <div>• Тип: {t.type}</div>
                                    {t.name && <div>Имя: {t.name}</div>}
                                    {/* If there's a schedule (per sensor or global), show it briefly */}
                                    {t.schedule && (
                                        <div>
                                            Расписание: {`с ${t.schedule.fromHour}:${String(t.schedule.fromMinute).padStart(2, '0')}`}
                                            {' до '}
                                            {`${t.schedule.untilHour}:${String(t.schedule.untilMinute).padStart(2, '0')}`}
                                        </div>
                                    )}
                                </div>
                            ))}
                        </div>
                    )}

                    {/* Optional: Show a brief summary of conditions */}
                    {scn.conditions && scn.conditions.length > 0 && (
                        <div style={{ marginTop: '8px' }}>
                            <strong>Условия:</strong>
                            {scn.conditions.map((c, idx) => (
                                <div key={idx} style={{ marginLeft: '15px' }}>
                                    <div>• {c.name} {c.operator} {c.value} ({c.logicOp})</div>
                                </div>
                            ))}
                        </div>
                    )}

                    <div style={{ marginTop: '10px', display: 'flex', gap: '10px' }}>
                        <button
                            onClick={() => toggleScenario(scn)}
                            style={{ marginRight: '10px' }}
                        >
                            {scn.isActive ? 'Выключить' : 'Включить'}
                        </button>
                        <button
                            onClick={() => runScenario(scn._id)}
                            style={{ marginRight: '10px' }}
                        >
                            Запустить вручную
                        </button>
                        <button
                            onClick={() => deleteScenario(scn._id)}
                            style={{
                                backgroundColor: 'red',
                                color: '#fff',
                                border: 'none',
                                padding: '5px 8px',
                                marginRight: '10px'
                            }}
                        >
                            Удалить
                        </button>
                        <button
                            onClick={() => handleEditScenario(scn._id, scn.scenarioName)}
                            style={{
                                backgroundColor: 'orange',
                                color: '#000',
                                border: 'none',
                                padding: '5px 8px'
                            }}
                        >
                            Редактировать
                        </button>
                    </div>
                </div>
            ))
        )}
        </div>
    );
}

export default ChooseScenario;
